<ng-container *ngIf="tripType$ | async as tripType">
  <section
    class="relative block-offer shadow-small fill grow flex flex--column no-underline nordic-blue-25-bg rounded-large overflow-hidden"
    (click)="emitClick(GlobalBookingTravelClass.MIXED, tripType); navigateToUrl(offer.link)"
    *ngIf="blockOffer$ | async as offer"
    [class.inner-hover]="innerLinkHover"
    data-test-destination-link
  >
    <div class="offer-area white-bg grow">
      <section class="destination-image relative" *ngIf="aspectRatio$ | async">
        <fin-content-image
          [aspectRatio$]="aspectRatio$"
          [imageData$]="offer.imageData | finToObservable"
          [maxImageWidth]="MaxImageWidth"
        >
        </fin-content-image>
      </section>

      <div
        *ngIf="badgeLabel$ | async as badgeLabel"
        data-test-badge-label
        class="absolute offer-badge rounded-top-left-medium rounded-bottom-left-medium"
      >
        <div
          class="offer-badge-content font-body-2 medium-type white-text ps-xxsmall-y ps-xsmall-x relative"
          [class.black-bg]="offer.enableBlackTeaser"
          [class.heather-700-bg]="!offer.enableBlackTeaser"
        >
          <div class="flex flex--row flex--top">
            <div class="flex-1">{{ 'destinationSearch.' + badgeLabel | finLocalization }}</div>
            <div class="offer-badge-icon flex--nogrow" *ngIf="offer.badgeIcon">
              <fcom-icon class="white-text ir-xxsmall" [name]="offer.badgeIcon"></fcom-icon>
            </div>
          </div>
        </div>
      </div>

      <section class="fill ps-medium destination-text-content">
        <a
          *ngIf="offer.title"
          class="no-decoration"
          [finLink]="offer.link"
          (beforeNavigation)="emitClick(GlobalBookingTravelClass.MIXED, tripType)"
          data-test-price-link
        >
          <h3 class="font-heading-5 nordic-blue-900-text mr-clear-y">{{ offer.title }}</h3>
          <ng-container [ngTemplateOutlet]="price" [ngTemplateOutletContext]="getPriceContext(offer)"> </ng-container>
        </a>
      </section>
    </div>
    <ng-container *ngIf="offer?.amDestination && flightHotelEnabled">
      <a
        (click)="openAmContinueModalClick(offer?.amDestination.bookUrl); $event.stopPropagation()"
        (mouseenter)="innerLinkHover = true"
        (mouseleave)="innerLinkHover = false"
        class="block flight-hotel no-underline ps-small-x"
        data-test-flight-hotel-price-link
      >
        <span class="flex flex--space-between flex--wrap ps-small-b">
          <span class="nordic-blue-900-text font-body-1 medium-type underline ps-small-t flex-1">
            {{ 'destinationSearch.flightsAndHotel' | finLocalization }}</span
          >
          <span class="nordic-blue-900-text font-body-1 ps-small-t fh-duration">
            {{
              'destinationSearch.flightAndHotelDuration' | finLocalization: { days: offer?.amDestination.duration }
            }}</span
          >
          <span
            class="nordic-blue-900-text font-body-1 ps-xsmall-l medium-type fh-price flex--self-end"
            data-test-price-value
            >{{ offer?.amDestination.price | finPrice: true | finEmpty }}</span
          >
        </span>
      </a>
    </ng-container>

    <ng-template #price let-price="price">
      <ng-container *ngIf="price && price.price; else noPrice">
        <div class="nordic-blue-900-text mr-clear-t font-body-1 ps-xxsmall-y" data-test-starting-from-label>
          {{ 'productCard.startingFromTitle.' + TripTypeMapping[tripType] | finLocalization }}
        </div>
        <span
          class="nordic-blue-900-text font-heading-2"
          [class.heather-700-text]="isHighlightPrice$ | async"
          data-test-price-value
          >{{ price.price | finPrice: true | finEmpty }}</span
        >
      </ng-container>
    </ng-template>

    <ng-template #noPrice>
      <div class="flex flex--middle mr-clear-t ps-small-y">
        <span class="nordic-blue-900-text font-body-1 ms-xxsmall-r" data-test-no-price-label>{{
          'productCard.noPriceText' | finLocalization
        }}</span>
        <fcom-icon class="is-xxsmall nordic-blue-900-text" category="svg-library" name="arrow-right"></fcom-icon>
      </div>
    </ng-template>
  </section>
</ng-container>
